export default __webpack_public_path__ + "static/media/usage_map.92508c93.png";